import { useState } from 'react';

import { maxLength, minLength } from '@app/constants';

import type { OrganizationsFilterFormValues } from '@pages/Organizations/OrganizationsList/Organizations.types';

const validationRules = {
  term: [minLength(2), maxLength()],
};

export const useFilterForm = () => {
  const [values, setValues] = useState<OrganizationsFilterFormValues>();
  const reset = () => {
    setValues(undefined);
  };
  const submit = (values: OrganizationsFilterFormValues) => {
    setValues(values);
  };

  return {
    rules: validationRules,
    values,
    reset,
    submit,
  };
};
